import React from 'react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import Paper from '@mui/material/Paper'

const Breathing = ({ moduleValues, setModuleValues }) => (
    <Grid item xs={12} lg={6}>
      <FormControl fullWidth>
        <InputLabel>Breathing</InputLabel>
        <Select
          value={moduleValues?.['Breathing'] ?? ''}
          onChange={(e) => setModuleValues(prev => ({...prev, ['Breathing']: e.target.value}))
          }
          label="Breathing"
        >
          <MenuItem value="Normal">Normal</MenuItem>
          <MenuItem value="Laboured">Laboured</MenuItem>
          <MenuItem value="Fast">Fast</MenuItem>
          <MenuItem value="Absent">Absent</MenuItem>
        </Select>
      </FormControl>
    </Grid>
)

export default Breathing
